import { useLocation } from '@reach/router';
import type { WindowLocation, RouteComponentProps } from '@reach/router';
import type React from 'react';

import { ShareTabView } from '@xing-com/crate-social-share';
import type { BackendTrackingMetaData } from '@xing-com/crate-social-types';

import { HOST_MESSAGES, SHARE_FINAL_TARGET } from '../../constants';
import type {
  ShareFinalTarget,
  ShareTarget,
  ShareZenViewQuery,
} from '../../types';
import { mapShareTarget, sendMessageToHost } from '../../utils';

import * as Styled from './share-zen-view.style';

const getQueryParams = (location: WindowLocation): ShareZenViewQuery => {
  const searchParams = new URLSearchParams(location.search);
  return {
    shareTarget: (searchParams.get('shareTarget') as ShareTarget) || '',
    params: JSON.parse(searchParams.get('params') || '{}'),
    interactionTargetUrn: searchParams.get('interactionTargetUrn') || '',
    preventPropagation: searchParams.get('preventPropagation') === 'true',
    borderLess: searchParams.get('borderLess') === 'true',
    shareableUrn: searchParams.get('shareableUrn'),
    url: searchParams.get('url') || '',
    entryPoint:
      searchParams.get('entryPoint') || 'share_extension_social_share',
    propSocialInteractionId: searchParams.get('propSocialInteractionId') || '',
    openWithShareTo:
      (searchParams.get('openWithShareTo') as ShareFinalTarget) ||
      SHARE_FINAL_TARGET.FEED,
    tabbed: searchParams.get('tabbed') === 'true',
    trackingContext: searchParams.get('trackingContext') || undefined,
    trackingId: searchParams.get('trackingId'),
    propChannel: searchParams.get('propChannel') || 'wbm/Share_Extension',
    propSourceType: searchParams.get('propSourceType') || '',
  };
};

export const ShareZenView: React.FunctionComponent<RouteComponentProps> = (
  props
) => {
  const location = useLocation();
  const queryParams = getQueryParams(location);
  const isShareZenViewQuery = !!queryParams.shareableUrn;

  const backendTrackingMetaData: BackendTrackingMetaData =
    queryParams.trackingId === null
      ? {}
      : {
          page: '',
          trackingTokens: [queryParams.trackingId],
          position: '',
        };
  if (isShareZenViewQuery) {
    return (
      <Styled.ShareContainer
        $borderless={queryParams.borderLess}
        $tabbed={queryParams.tabbed}
      >
        <ShareTabView
          onSuccess={() => sendMessageToHost(HOST_MESSAGES.SUCCESS)}
          onError={() => sendMessageToHost(HOST_MESSAGES.ERROR)}
          onCancel={() => sendMessageToHost(HOST_MESSAGES.CANCEL)}
          {...queryParams}
          backendTrackingMetaData={backendTrackingMetaData}
          verb="SHARE"
          openWithShareTo={mapShareTarget(
            queryParams.shareTarget,
            queryParams.openWithShareTo
          )}
          {...props}
        />
      </Styled.ShareContainer>
    );
  } else {
    return null;
  }
};
